const parseDate = date => {
  const parsedDate = Date.parse(date)
  if (!isNaN(parsedDate)) return parsedDate

  const splitDate = date.split(/[^0-9]/)
  return new Date(splitDate[0], splitDate[1] - 1, splitDate[2], splitDate[3], splitDate[4], splitDate[5])
}

export default parseDate
